export interface Anime {
  id: string;
  title: string;
  tags: string[];
  score: number;
  year: string;
  episodes: string;
  studio: string;
  synopsis: string;
  image: string;
}

export interface Category {
  name: string;
  icon: string;
  count: number;
  desc: string;
}

export interface Testimonial {
  name: string;
  role: string;
  content: string;
}

export interface Faq {
  q: string;
  a: string;
}

export const animeList: Anime[] = [
  {
    id: "frieren",
    title: "葬送的芙莉莲",
    tags: ["奇幻", "治愈", "群像"],
    score: 9.4,
    year: "2023",
    episodes: "28集",
    studio: "MADHOUSE",
    synopsis: "勇者一行打倒魔王后的世界，精灵魔法使芙莉莲带着对同伴的思念踏上漫长旅途，在回忆与告别中重新理解生命与羁绊，温暖而深沉。",
    image: "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20serene%20silver-haired%20elven%20mage%20in%20a%20white%20robe%20walking%20through%20a%20vast%20flowery%20meadow%2C%20soft%20warm%20coral%20and%20amber%20sunset%20light%2C%20dreamy%20magical%20particles%2C%20detailed%20anime%20background%20art%2C%20gentle%20nostalgic%20atmosphere%2C%20portrait%20anime%20poster&width=800&height=1000&seq=anime-frieren&orientation=portrait"
  },
  {
    id: "spy-family",
    title: "间谍过家家",
    tags: ["日常", "喜剧", "家庭"],
    score: 8.8,
    year: "2022",
    episodes: "37集",
    studio: "WIT STUDIO",
    synopsis: "为了各自的目的，间谍、杀手与超能力女孩组成一个「临时家庭」，在互相隐瞒身份的日子里，却意外收获了最真实的温暖与欢乐。",
    image: "https://readdy.ai/api/search-image?query=Cheerful%20anime%20key%20visual%20of%20a%20pink-haired%20girl%2C%20a%20blond%20man%20in%20a%20suit%20and%20a%20black-haired%20woman%20standing%20together%20in%20front%20of%20a%20cozy%20city%20street%2C%20warm%20golden%20afternoon%20light%2C%20family%20comedy%20vibe%2C%20vibrant%20coral%20and%20amber%20color%20palette%2C%20detailed%20anime%20poster%20art&width=800&height=1000&seq=anime-spy&orientation=portrait"
  },
  {
    id: "aot",
    title: "进击的巨人",
    tags: ["热血", "史诗", "黑暗"],
    score: 9.2,
    year: "2013",
    episodes: "全季",
    studio: "MAPPA",
    synopsis: "高墙之内的人类为自由而战，艾伦与同伴们直面巨人的威胁。宏大世界观与深刻的人性叩问，堪称当代动画的里程碑之作。",
    image: "https://readdy.ai/api/search-image?query=Epic%20anime%20key%20visual%20of%20a%20determined%20young%20soldier%20with%20dark%20hair%20surveying%20a%20massive%20stone%20wall%20under%20a%20fiery%20orange%20sky%2C%20dramatic%20warm%20lighting%2C%20floating%20ash%2C%20epic%20scale%2C%20dark%20warm%20tones%20with%20coral%20highlights%2C%20cinematic%20anime%20poster&width=800&height=1000&seq=anime-aot&orientation=portrait"
  },
  {
    id: "your-name",
    title: "你的名字",
    tags: ["恋爱", "奇幻", "催泪"],
    score: 9.0,
    year: "2016",
    episodes: "剧场版",
    studio: "CoMix Wave",
    synopsis: "住在乡下的少女与东京的少年在梦中互换身体，跨越时空与灾难的追寻。新海诚导演的国民级纯爱代表作，每一帧都是壁纸。",
    image: "https://readdy.ai/api/search-image?query=Romantic%20anime%20key%20visual%20of%20a%20young%20couple%20meeting%20under%20a%20glowing%20warm%20orange%20comet%20sky%20above%20a%20quiet%20town%2C%20soft%20coral%20and%20gold%20light%2C%20sparkling%20stars%2C%20dreamy%20wistful%20atmosphere%2C%20beautiful%20anime%20poster%20illustration&width=800&height=1000&seq=anime-yourname&orientation=portrait"
  },
  {
    id: "jjk",
    title: "咒术回战",
    tags: ["热血", "奇幻", "战斗"],
    score: 8.6,
    year: "2020",
    episodes: "47集",
    studio: "MAPPA",
    synopsis: "少年虎杖悠仁为救人吞下诅咒之指，自此踏入咒术师的世界。高速战斗与帅气角色，燃到极致的现代咒术物语。",
    image: "https://readdy.ai/api/search-image?query=Stylish%20dark%20anime%20key%20visual%20of%20a%20boy%20with%20spiky%20dark%20hair%20holding%20a%20glowing%20cursed%20blade%2C%20dramatic%20black%20and%20warm%20crimson%20red%20energy%2C%20intense%20action%2C%20high%20contrast%20warm%20highlights%2C%20edgy%20cool%20anime%20poster&width=800&height=1000&seq=anime-jjk&orientation=portrait"
  },
  {
    id: "demon-slayer",
    title: "鬼灭之刃",
    tags: ["热血", "冒险", "亲情"],
    score: 8.7,
    year: "2019",
    episodes: "全季",
    studio: "ufotable",
    synopsis: "炭治郎为拯救变成鬼的妹妹祢豆子踏上斩鬼之旅。精美的战斗作画与真挚的兄妹羁绊，风靡全球的现象级作品。",
    image: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20key%20visual%20of%20a%20cheerful%20boy%20with%20a%20scarred%20face%20gripping%20a%20katana%2C%20flowing%20water%20effect%20in%20warm%20orange%20and%20gold%20light%2C%20energetic%20action%20pose%2C%20vibrant%20coral%20and%20amber%20palette%2C%20detailed%20anime%20poster&width=800&height=1000&seq=anime-demonslayer&orientation=portrait"
  },
  {
    id: "bocchi",
    title: "孤独摇滚！",
    tags: ["日常", "音乐", "治愈"],
    score: 8.9,
    year: "2022",
    episodes: "12集",
    studio: "CloverWorks",
    synopsis: "极度社恐的吉他少女后藤一里，机缘巧合加入乐团「结束乐队」，在音乐与伙伴的陪伴下一点点走出自己的小小世界。",
    image: "https://readdy.ai/api/search-image?query=Cute%20anime%20key%20visual%20of%20a%20shy%20pink-haired%20girl%20with%20long%20bangs%20holding%20an%20electric%20guitar%2C%20warm%20cozy%20club%20room%20background%2C%20soft%20coral%20and%20amber%20light%2C%20slice%20of%20life%20music%20vibe%2C%20kawaii%20anime%20poster&width=800&height=1000&seq=anime-bocchi&orientation=portrait"
  },
  {
    id: "death-note",
    title: "死亡笔记",
    tags: ["悬疑", "智斗", "犯罪"],
    score: 9.1,
    year: "2006",
    episodes: "37集",
    studio: "MADHOUSE",
    synopsis: "天才少年夜神月捡到一本写下名字就能杀人的笔记本，与神秘侦探L展开一场世纪智力对决。烧脑悬疑的经典之作。",
    image: "https://readdy.ai/api/search-image?query=Moody%20anime%20key%20visual%20of%20a%20pale%20young%20man%20in%20a%20dark%20coat%20holding%20a%20mysterious%20notebook%2C%20dramatic%20warm%20lamp%20light%20in%20a%20shadowy%20room%2C%20suspenseful%20atmosphere%2C%20dark%20brown%20and%20amber%20tones%2C%20noir%20anime%20poster&width=800&height=1000&seq=anime-deathnote&orientation=portrait"
  },
  {
    id: "weathering",
    title: "天气之子",
    tags: ["恋爱", "奇幻", "治愈"],
    score: 8.5,
    year: "2019",
    episodes: "剧场版",
    studio: "CoMix Wave",
    synopsis: "离家出走的少年在东京遇到能改变天气的「晴女」阳菜，一场关于选择、牺牲与爱的奇幻冒险就此展开。",
    image: "https://readdy.ai/api/search-image?query=Romantic%20anime%20key%20visual%20of%20a%20boy%20and%20a%20girl%20sharing%20an%20umbrella%20under%20a%20glowing%20warm%20orange%20sky%20with%20drifting%20clouds%20and%20light%20rain%2C%20coral%20and%20gold%20light%2C%20dreamy%20emotional%20atmosphere%2C%20beautiful%20anime%20poster&width=800&height=1000&seq=anime-weathering&orientation=portrait"
  },
  {
    id: "haikyuu",
    title: "排球少年",
    tags: ["运动", "热血", "青春"],
    score: 9.0,
    year: "2014",
    episodes: "全季",
    studio: "Production I.G",
    synopsis: "矮个子少年日向翔阳与天才二传影山飞雄组成搭档，带领乌野高中排球部向全国大赛发起冲击，纯粹的青春热血。",
    image: "https://readdy.ai/api/search-image?query=High%20energy%20anime%20key%20visual%20of%20a%20short%20orange-haired%20boy%20leaping%20to%20spike%20a%20volleyball%20in%20a%20bright%20gymnasium%2C%20warm%20golden%20arena%20light%2C%20dynamic%20motion%2C%20passionate%20sports%20vibe%2C%20coral%20and%20amber%20palette%2C%20anime%20poster&width=800&height=1000&seq=anime-haikyuu&orientation=portrait"
  },
  {
    id: "summer-time",
    title: "夏日重现",
    tags: ["悬疑", "奇幻", "惊悚"],
    score: 8.8,
    year: "2022",
    episodes: "25集",
    studio: "OLM",
    synopsis: "回到故乡参加青梅竹马葬礼的慎平，发现小岛被神秘的影子所笼罩，在无限循环的时间里步步逼近真相。",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20anime%20key%20visual%20of%20a%20young%20man%20with%20dark%20hair%20on%20a%20quiet%20seaside%20island%20town%20at%20warm%20sunset%2C%20shadowy%20ominous%20undertones%20with%20coral%20sky%2C%20suspenseful%20island%20mystery%20atmosphere%2C%20anime%20poster&width=800&height=1000&seq=anime-summertime&orientation=portrait"
  },
  {
    id: "mob",
    title: "灵能百分百",
    tags: ["热血", "喜剧", "成长"],
    score: 8.7,
    year: "2016",
    episodes: "37集",
    studio: "BONES",
    synopsis: "拥有超强灵能力的少年影山茂夫，在日常琐事与灵力战斗之间摸索成长。看似不起眼，爆发时却震撼人心。",
    image: "https://readdy.ai/api/search-image?query=Playful%20anime%20key%20visual%20of%20a%20blank-faced%20boy%20with%20a%20bowl%20haircut%20surrounded%20by%20glowing%20psychic%20energy%20in%20a%20warm%20orange%20aura%2C%20comedic%20yet%20cool%2C%20vibrant%20coral%20energy%20effects%2C%20clean%20anime%20poster&width=800&height=1000&seq=anime-mob&orientation=portrait"
  },
  {
    id: "violet",
    title: "紫罗兰永恒花园",
    tags: ["治愈", "奇幻", "感人"],
    score: 8.9,
    year: "2018",
    episodes: "13集",
    studio: "京都动画",
    synopsis: "曾是战争兵器的少女薇尔莉特，成为代笔人后通过一封封书信理解「爱」为何物。画面唯美，每一集都催人泪下。",
    image: "https://readdy.ai/api/search-image?query=Gentle%20anime%20key%20visual%20of%20a%20graceful%20blonde%20young%20woman%20in%20a%20blue%20dress%20writing%20on%20a%20typewriter%20by%20a%20warm%20window%2C%20golden%20sunset%20light%2C%20soft%20melancholic%20beauty%2C%20warm%20coral%20and%20amber%20tones%2C%20elegant%20anime%20poster&width=800&height=1000&seq=anime-violet&orientation=portrait"
  },
  {
    id: "kaguya",
    title: "辉夜大小姐想让我告白",
    tags: ["恋爱", "喜剧", "校园"],
    score: 8.8,
    year: "2019",
    episodes: "37集",
    studio: "A-1 Pictures",
    synopsis: "天才与天才的恋爱头脑战！副会长辉夜与会长白银都等着对方先告白，一出出让人捧腹的「先告白就输了」大戏。",
    image: "https://readdy.ai/api/search-image?query=Romantic%20comedy%20anime%20key%20visual%20of%20a%20handsome%20dark-haired%20boy%20and%20a%20beautiful%20raven-haired%20girl%20at%20a%20school%20desk%20exchanging%20glances%2C%20warm%20golden%20light%2C%20playful%20blush%20tones%2C%20coral%20and%20amber%20palette%2C%20charming%20anime%20poster&width=800&height=1000&seq=anime-kaguya&orientation=portrait"
  },
];

export const categoryList: Category[] = [
  { name: "恋爱", icon: "ri-heart-3-line", count: 128, desc: "纯爱、虐恋与心跳日常" },
  { name: "热血", icon: "ri-fire-line", count: 156, desc: "燃到极致的战斗与成长" },
  { name: "治愈", icon: "ri-sun-line", count: 98, desc: "温柔抚平疲惫的慢时光" },
  { name: "悬疑", icon: "ri-spy-line", count: 76, desc: "烧脑反转与沉浸谜题" },
  { name: "奇幻", icon: "ri-magic-line", count: 143, desc: "异世界与神秘想象" },
  { name: "日常", icon: "ri-home-smile-line", count: 112, desc: "平淡生活里的闪光" },
  { name: "运动", icon: "ri-basketball-line", count: 54, desc: "汗水与青春拼搏" },
  { name: "音乐", icon: "ri-music-2-line", count: 43, desc: "旋律与追梦故事" },
];

export const matchReasons: string[] = [
  "慢节奏叙事爱好者，偏爱细腻的情感刻画",
  "喜欢群像成长与关于「告别」的温柔表达",
  "近期心情需要一场治愈的陪伴式冒险",
  "对奇幻世界观与中世纪氛围毫无抵抗力",
  "正在寻找能静下心慢慢品味的深度佳作",
];

export const testimonials: Testimonial[] = [
  {
    name: "柚子",
    role: "入坑两年的老观众",
    content: "之前总是翻番剧列表翻到半夜也选不出来，小缘的缘分匹配一下就把我的「下一部」送到面前，真的对上了我的电波。",
  },
  {
    name: "阿青",
    role: "上班族追番党",
    content: "随缘漫游模式太适合我这种没时间研究剧情的人，刷到什么看什么，每次都有新惊喜，连冷门佳作都能被翻出来。",
  },
  {
    name: "小满",
    role: "ACG 新粉",
    content: "盲盒番剧开出《葬送的芙莉莲》的那一刻我整个人都惊了，结果一看就停不下来。这缘分匹配是真有点东西。",
  },
];

export const faqs: Faq[] = [
  {
    q: "今日缘分匹配是怎么帮我看番的？",
    a: "小缘动漫库会综合你的看番偏好（叙事节奏、题材口味、当前心情）与当下热门作品，为你生成一份专属的今日看番清单，并说明「为什么会推荐它」，让你不用纠结直接开看。",
  },
  {
    q: "盲盒番剧开出来的一定会好看吗？",
    a: "盲盒番剧里的每一部都经过了小缘的筛选与口碑把关，保证是值得一看的优质作品。未知的惊喜来自「你会抽到哪一部」，而不是赌上烂片的风险，可以放心开盒。",
  },
  {
    q: "随缘漫游和随机推荐有什么区别？",
    a: "随机推荐是单部作品的一次性推荐；随缘漫游则是一种「交给命运」的连续浏览模式，每次刷新都会从整个片库中为你翻出下一部，适合彻底告别选择困难的沉浸式漫游体验。",
  },
  {
    q: "我可以自由切换喜欢的题材吗？",
    a: "可以。你可以在「动漫分类」板块按恋爱、热血、治愈、悬疑等题材快速切换，缘分匹配与随机推荐都会优先参考你当前关注的分类，让推荐更合口味。",
  },
  {
    q: "小缘动漫库需要付费吗？",
    a: "小缘动漫库的核心推荐功能完全免费，包括今日缘分匹配、盲盒番剧与随缘漫游。我们只做「帮你找到下一部好番」这件事，不设付费门槛。",
  },
  {
    q: "推荐的番剧在哪里可以观看？",
    a: "小缘动漫库负责为你精准推荐作品并提供观看引导，具体片源与播放平台请以正规视频平台为准。请支持正版，一起守护每一部好作品。",
  },
];